import { createSelector } from 'reselect'

import { selectConfigurationState } from './selectConfigurationState'

export const selectPartner360Uid = createSelector(
  [selectConfigurationState],
  ({ data }) => data.uid
)
